import { useI18n } from "@/context/I18nContext";

export default function LanguageSwitcher({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex border border-slate-200 rounded-sm overflow-hidden text-[11px] font-mono uppercase tracking-wider ${className}`} data-testid="lang-switcher">
      <button
        onClick={() => setLang("fr")}
        className={`px-2 py-1 transition-colors ${lang === "fr" ? "bg-slate-900 text-white" : "bg-white text-slate-600 hover:bg-slate-50"}`}
        data-testid="lang-fr"
        aria-pressed={lang === "fr"}
      >
        FR
      </button>
      <button
        onClick={() => setLang("en")}
        className={`px-2 py-1 transition-colors border-l border-slate-200 ${lang === "en" ? "bg-slate-900 text-white" : "bg-white text-slate-600 hover:bg-slate-50"}`}
        data-testid="lang-en"
        aria-pressed={lang === "en"}
      >
        EN
      </button>
    </div>
  );
}
